import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { RatesApiAdapter } from '../adapters/RatesApiAdapter';

export const useChangeRateStatus = () => {
  const queryClient = useQueryClient();

  const adapter = useMemo(() => {
    const httpClient = createHttpClient(apiClientWH);
    return new RatesApiAdapter(httpClient);
  }, []);

  return useMutation<void, Error, number>({
    mutationFn: (rateId: number) => adapter.changeRateStatus(rateId),
    onSuccess: (_, rateId) => {
      queryClient.invalidateQueries({ queryKey: ['rate', rateId] });
      queryClient.invalidateQueries({ queryKey: ['rates'] });
    },
  });
};
